<template>
  <div class="p-luck">
    <div class="p-modal" v-if="showModal">
      <div class="content-box">
        <img
          @click="showModal = false"
          class="close"
          src="/images/close.png"
          alt=""
        />
        <div class="content">
          <div class="img-box">
            <img :src="list[activeIndex].img" alt="" />
            <span>{{ list[activeIndex].title }}</span>
          </div>

          <div class="text-box">
            <h4 class="title">
              恭喜您获得 <br />
              “ {{ list[activeIndex].title }} ”
            </h4>
            <template v-if="status === 2">
              <p style="text-align: center; color: #ccc">(已领奖)</p>
            </template>
            <template v-else>
              <el-divider>领奖步骤</el-divider>
              <p>1. 联系现场工作人员并出示此页面(展位号：1Q52)</p>
              <p>
                2.
                <a
                  @click="award"
                  style="text-decoration: underline; color: #FF2200;"
                  >确认领奖</a
                >
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
    <img class="bg bg-top" src="/images/bg-top.png" alt="" />
    <div class="main">
      <img class="img-title" src="/images/title.png" alt="" />
      <lottery
        @lotteryClick="lotteryClick"
        @lotteryDone="lotteryDone"
        :lottery-start="lotteryStart"
        :lottery-prizenum="prizeNum"
        :lottery-prizeno="prizeNo"
        class="m-lottery"
        lottery-bg="/images/turnplate-bg.png"
        content-bg="/images/turntable.png"
        :pointer-bg="pointerImage"
        :lottery-width="['75%', '30%']"
      ></lottery>
      <h4>
        已有 <span>{{ number }}</span> 人参加活动
      </h4>
      <div class="text-box">
        <div class="title">活动说明</div>
        <div class="content">
          <p>
            1. 活动有效时间: 2019.12.19-2019.12.21
          </p>
          <p>
            2. 活动规则:
            本活动仅限2019深圳国际电子展参会人员参加，每人有且只有一次抽奖机会，礼品现场直接兑换。
          </p>
          <p>3. 本活动最终解释权深圳市正能量网络技术有限公司</p>
        </div>
      </div>
    </div>
    <img class="bg bg-bottom" src="/images/bg-bottom.png" alt="" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import API from "@/api/index";
export default {
  name: "app",
  data() {
    return {
      lotteryStart: 0,
      prizeNo: 1,
      activeIndex: 0,
      prizeNum: 6,
      number: 66,
      // 领奖状态
      status: 0,
      loading: false,
      showModal: false,
      pointerImage: "/images/pointer.png",
      bingoImage: "/images/award-huawei.png",
      list: [
        {
          pid: 5,
          title: "签字笔",
          img: "/images/award-pen.png",
          id: 1
        },
        {
          pid: 2,
          title: "便携充电宝",
          img: "/images/award-power.png",
          id: 2
        },
        {
          pid: 6,
          title: "高品质保温杯",
          img: "/images/award-VacuumCup.png",
          id: 3
        },
        {
          pid: 3,
          title: "无线蓝牙耳机",
          img: "/images/award-earphones.png",
          id: 4
        },
        {
          pid: 4,
          title: "多功能数据线",
          img: "/images/award-line.png",
          id: 5
        },
        {
          pid: 1,
          title: "华为P30 Pro",
          img: "/images/award-huawei.png",
          id: 6
        }
      ]
    };
  },
  computed: {
    ...mapState({
      token: state => state.token
    })
  },
  created() {
    API.getNumber(this.token).then(res => {
      this.number = res.Data;
    });
  },
  components: {},
  methods: {
    async lotteryClick() {
      if (!this.token) {
        location.reload();
      }
      const result = await API.luckdraw(this.token);
      this.status = result.Data.Status;
      const pid = result.Data.ProductId;
      this.list.map((item, index) => {
        if (item.pid === pid) {
          this.activeIndex = index;
          this.prizeNo = item.id;
        }
      });
      this.lotteryStart = 1;
      this.pointerImage = "/images/pointer-active.png";
    },
    lotteryDone() {
      this.lotteryStart = 0;
      this.pointerImage = "/images/pointer.png";
      this.showModal = true;
    },
    award() {
      API.award(this.token).then(() => {
        this.status = 2;
      });
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
$content-width: 85%;
* {
  margin: 0;
  padding: 0;
}
.p-luck {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffcc80;

  .img-title {
    display: block;
    margin: 0 auto;
    width: $content-width;
  }
  .main {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    min-height: 100vh;
    z-index: 1;
    overflow: auto;
    .m-lottery {
      width: $content-width;
      margin-top: 40px;
    }
    > h4 {
      font-weight: normal;
      margin-bottom: 20px;
      font-size: 18px;
      span {
        color: #1489dd;
      }
    }
    .text-box {
      margin-bottom: 35px;
      width: $content-width;
      border: 2px solid #efcb39;
      border-radius: 5px;
      background-color: #fff6c0;
      .title {
        text-align: center;
        line-height: 44px;
        font-size: 20px;
        color: #af5800;
        background-color: #feeca3;
      }
      > .content {
        padding: 8px;
        font-size: 14px;
        line-height: 26px;
        color: #8e8d73;
        > p {
          padding: 4px 0;
        }
      }
    }
  }
  .bg {
    position: absolute;
    width: 100%;
    z-index: 0;
    height: auto;
  }
  .bg-top {
    top: 0;
  }
  .bg-bottom {
    bottom: 0;
  }
}
.p-modal {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);

  .content-box {
    position: relative;
    display: flex;
    width: $content-width;
    justify-content: center;
    .close {
      position: absolute;
      width: auto;
      height: 80px;
      top: -80px;
      right: 10px;
    }
  }

  .content {
    position: relative;
    width: 100%;
    background-color: #fff;
    border-radius: 25px;
    overflow: hidden;
    // 微信浏览器图片border-radius有兼容性问题
    .img-box {
      position: relative;
      width: 100%;
      img {
        width: 100%;
      }
      span {
        position: absolute;
        left: 50%;
        bottom: 10px;
        color: #fff;
        font-size: 18px;
        transform: translateX(-50%);
      }
    }
    .text-box {
      margin: 20px auto;
      width: 80%;
      font-size: 16px;
      color: #2288cc;
      .title {
        text-align: center;
        font-size: 18px;
        font-weight: normal;
        color: #333;
      }
      .el-divider__text {
        font-size: 14px;
        color: #b3b3b3;
        font-weight: normal;
      }
      p {
        font-weight: 600;
        margin: 6px 0;
      }
    }
  }
}
</style>
